import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { MenuDataLocaleContext } from "../../menudata/context/MenuDataLocaleContext";
import { getGuestPlatformFeeEnabled } from "../../order/selectors/restaurantFlags";
import { getSurchargeMessageText } from "../util/getSurchargeMessageText";

export const SurchargeMessage = () => {
    const menuDataLocale = useContext(MenuDataLocaleContext);
    const guestPlatformFeeEnabled = useSelector(getGuestPlatformFeeEnabled);

    return <>{getSurchargeMessageText(menuDataLocale, guestPlatformFeeEnabled)}</>;
};
